import omit from 'lodash.omit';

// Global Types
import { ResetStateAction } from 'services/auth/types';

// Global Constants
// @ts-ignore
import { SET_CURRENT_ORGANIZATION_ID } from 'services/currentOrganizationId/constants';
import { RESET_STATE } from 'services/auth/constants';

// Local Types
import { MyTimesheetEntriesState, MyTimesheetEntriesTypes } from './types';

// Local Constants
import {
    MY_TIMESHEET_ENTRY_ADD,
    MY_TIMESHEET_ENTRY_UPDATE,
    MY_TIMESHEET_ENTRY_REMOVE,
    MY_TIMESHEET_ENTRIES_SET_READ_ONLY,
    MY_TIMESHEET_ENTRIES_SET,
    MY_TIMESHEET_ENTRIES_MERGE,
    MY_TIMESHEET_ENTRIES_DELETE
} from './constants';

export const initialState: MyTimesheetEntriesState = {
    readOnlyValues: {},
    initialValues: {},
    values: {}
};

export default function (
    state: MyTimesheetEntriesState = initialState,
    action: MyTimesheetEntriesTypes | ResetStateAction
): MyTimesheetEntriesState {
    switch (action.type) {
        case MY_TIMESHEET_ENTRY_ADD:
        case MY_TIMESHEET_ENTRY_UPDATE:
            return {
                ...state,
                values: {
                    ...state.values,
                    [action.payload.uuid]: action.payload
                }
            };
        case MY_TIMESHEET_ENTRY_REMOVE:
            return {
                ...state,
                values: omit(state.values, action.payload)
            };
        case MY_TIMESHEET_ENTRIES_SET_READ_ONLY:
            return {
                ...state,
                readOnlyValues: action.payload
            };
        case MY_TIMESHEET_ENTRIES_SET: {
            const { payload } = action;
            return {
                ...state,
                initialValues: payload,
                values: payload
            };
        }
        case MY_TIMESHEET_ENTRIES_MERGE:
            return {
                ...state,
                initialValues: {
                    ...state.initialValues,
                    ...action.payload
                },
                values: {
                    ...state.values,
                    ...action.payload
                }
            };
        case MY_TIMESHEET_ENTRIES_DELETE:
            return {
                ...state,
                initialValues: omit(state.initialValues, action.payload),
                values: omit(state.values, action.payload)
            };
        case SET_CURRENT_ORGANIZATION_ID:
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
